module.exports = __webpack_public_path__ + "static/media/performance-simulado.14737def.svg";